import { render, staticRenderFns } from "./GasContractBox.vue?vue&type=template&id=db3d6c34&"
import script from "./GasContractBox.vue?vue&type=script&lang=ts&"
export * from "./GasContractBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports